import { render, staticRenderFns } from "./cake.vue?vue&type=template&id=b6e64b5c&scoped=true&"
import script from "./cake.vue?vue&type=script&setup=true&lang=ts&"
export * from "./cake.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e64b5c",
  null
  
)

export default component.exports